

export class DesignationOutputWithStatus implements IDesignationOutputWithStatus {
    /** The auto-generated id of the designation master */
    designation_id!: number;
    /** The designation name with 255 character limit */
    designation_name!: string;
    /** Manage status of designation. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IDesignationOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.designation_id = _data["designation_id"];
            this.designation_name = _data["designation_name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): DesignationOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new DesignationOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["designation_id"] = this.designation_id;
        data["designation_name"] = this.designation_name;
        data["status"] = this.status;
        return data; 
    }
}

export interface IDesignationOutputWithStatus {
    /** The auto-generated id of the designation master */
    designation_id: number;
    /** The designation name with 255 character limit */
    designation_name: string;
    /** Manage status of designation. 0 For De-active, 1 For Active */
    status: number;
}

